import React, { Component } from 'react'

export default class Googlemaps extends Component {
    render() {
        return (
            <div>
                <div class="google_map">
                        <div id="map-canvas"></div>
                    </div>
            </div>
        )
    }
}
